export const errorMessage = (caught: unknown): string => (caught instanceof Error ? caught.message : String(caught));
